import React, { useState, useEffect } from "react";

import { Layout } from "antd";
import Sidebar from "./components/SideBar/SideBar";
import Navigation from "./components/Navigation/Navigation";
import Footer from "./components/Footer/Footer";

const { Content } = Layout;

const AdminLayout = ({ children }) => {
  return (
    <Layout className="adminLayout">
      <Sidebar collapsed={false} />
      <Layout className="site-layout">
        <Navigation collapsed={false} visible={false} />
        <Content>{children}</Content>
        <Footer />
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
